"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADD_TO_DO_MODAL = void 0;
var ADD_TO_DO_MODAL = {
  TEXT__OUTLET: 'addToDoModal-span-outlet',
  TEXT__SELECTED_OUTLET: 'addToDoModal-span-selectedOUtlet',
  BUTTON__SELECT_OUTLET: 'addToDoModal-button-selectOutlet',
  BUTTON__CREATE_NEW_OUTLET: 'addToDoModal-button-createNewOutlet',
  BUTTON__ACCOUNT_REP: 'addToDoModal-button-accountRepresentative',
  BUTTON__DUE_DATE: 'addToDoModal-button-dueDate',
  BUTTON__CANCEL: 'addToDoModal-button-cancel',
  BUTTON__ADD_TODO: 'addToDoModal-button-addTodo',
  TEXTAREA__NOTE: 'addToDoModal-textarea-note'
};
exports.ADD_TO_DO_MODAL = ADD_TO_DO_MODAL;